import './App.css';
// Site content temporarily disabled — renders a blank white page.
// Restore by uncommenting these imports and the elements in App() below.
// import Navbar from './components/Navbar';
// import Hero from './components/Hero';
// import Services from './components/Services';
// import About from './components/About';
// import Gallery from './components/Gallery';
// import Contact from './components/Contact';
// import Footer from './components/Footer';

function App() {
  return (
    <div>
      {/*
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Gallery />
      <Contact />
      <Footer />
      */}
    </div>
  );
}

export default App;
